import { PreviewStatus, BuildStatus } from "@modules/graphql/types"

const statusMap = {
  [BuildStatus.Error]: PreviewStatus.BuildError,
  [BuildStatus.Success]: PreviewStatus.Ready,
}

export const mapBuildStatusToPreviewStatus = buildStatus =>
  statusMap[buildStatus]
